import { getUserConditionProfile } from 'modules/user/utils';

export const getCleanedTreatments = (treatments) => treatments?.filter((treatment) => treatment.drugs_received?.length);

export const hasTreatmentHistory = (user) => {
  const treatments = getUserConditionProfile(user)?.treatments;
  return !!treatments?.some((treatment) => !!treatment?.drugs_received?.length);
};
